import axios from 'axios';

// Dual-API: submit to both rvrex (CRM) and nurexify (ERP) simultaneously
const api1 = axios.create({ baseURL: "https://api.rvrex.com/" });
const api2 = axios.create({ baseURL: "https://infra-api.nurexify.com/" });

const Apis = () => {

    const saveContactFormdata = async (input_data) => {
        const payload = typeof input_data === "object" && !(input_data instanceof FormData)
            ? input_data
            : Object.fromEntries(input_data.entries?.() || []);

        if (!payload.source) payload.source = "Miracle";

        const config = { headers: { "Content-Type": "application/json" } };
        const [res1] = await Promise.all([
            api1.post("api/storefront/submitContact", payload, config),
            // api2.post("api/storefront/submitContact", payload, config),
        ]);
        return res1;
    };

    return { saveContactFormdata };
};

export default Apis;
